import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const MatrimonyList = () => {
    const [categories, setCategories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [dateOfBirthFilter, setDateOfBirthFilter] = useState("");
    const [birthYearFilter, setBirthYearFilter] = useState("");
    const [subcasteFilter, setSubcasteFilter] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [manglikFilter, setManglikFilter] = useState("");
    const [showModal, setShowModal] = useState(false);



    
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const history = useHistory();

    const token = localStorage.getItem('authToken');

    const getData = async () => {
        try {
            const queryParams = {
                page: currentPage,

                subcaste: subcasteFilter, // Add Subcaste filter
                city: cityFilter, // Add City filter
            };

            // Include Manglik filter only if it's not empty (i.e., not "All" option)
            if (manglikFilter !== "") {
                queryParams.manglik = manglikFilter === "true";
            }
            if (dateOfBirthFilter) {
                queryParams.dateOfBirth = new Date(dateOfBirthFilter).toISOString();
            }

            const response = await axios.get(`https://samaj.aasmo.in/api/admin/matrimony`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: queryParams,
            });
            setCategories(response.data.data);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.log(error);
        }
    };



    const handleEdit = (id) => {
        history.push(`/editmatrimony/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://samaj.aasmo.in/api/admin/matrimony/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response) {
                console.log("Deleted Successfully");
                getData();
            }
        } catch (error) {
            console.log(error);
        }
        setShowModal(false);
    };

    const handleDeleteClick = (id) => {
      
        setSelectedCategoryId(id);
        setShowModal(true);
    };

    useEffect(() => {
        getData();
    }, [currentPage, dateOfBirthFilter, subcasteFilter, cityFilter, manglikFilter]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handleDateOfBirthFilter = (e) => {
        setDateOfBirthFilter(e.target.value);
    };
    const handleSubcasteFilter = (e) => {
        setSubcasteFilter(e.target.value);
    };

    const handleCityFilter = (e) => {
        setCityFilter(e.target.value);
    };

    const handleManglikFilter = (e) => {
        setManglikFilter(e.target.value);
    };

    const handleDownload = () => {
        const fields = [
            "id",
            "userName",
            "fullName",
            "fathersName",
            "fatherMobile",
            "gender",
            "maritalStatus",
            "numOfBrothers",
            "numOfSisters",
            "manglik",
            "height",
            "bloodGroup",
            "dateOfBirth",
            "birthTime",
            "address",
            "mobileNo",
            "education",
            "subcaste",
            "profession",
           
            "perAnnum",
            "gotra",
            "city",
            "state",
            "pincode",
            "about",
            "packageName.title",
           
            "createdAt"
        ];

        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(categories);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'Matrimony_list.csv');
    }


    const formatDate = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is null or undefined

        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            //   hour: 'numeric',
            //   minute: 'numeric',
            //   timeZone: 'UTC' // Adjust timeZone as per your requirement
        };

        return new Date(dateString).toLocaleDateString(undefined, options);
    };



    return (
        <div className="col-lg-12">
            <div className="card">
                <div className="header">
                    <h2>Metrimony List</h2>
                </div>
                <div className="d-flex justify-content-start">
                    <div className="input-group m-b-10 col-lg-6">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                <i className="icon-magnifier"></i>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by Date of Birth"
                            value={dateOfBirthFilter}
                            onChange={handleDateOfBirthFilter}
                        />
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by Subcaste"
                            name="subCaste"
                            value={subcasteFilter}
                            onChange={handleSubcasteFilter}
                        />
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by City"
                            name="subCaste"
                            value={cityFilter}
                            onChange={handleCityFilter}
                        />


                        <select
                            className="form-control"
                            value={manglikFilter}
                            onChange={handleManglikFilter}
                        >
                            <option value="">All</option>
                            <option value="true">Manglik</option>
                            <option value="false">Non-Manglik</option>
                        </select>
                    </div>

                    <div>
                        <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
                    </div>
                </div>
                <div className="body table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>ID</th>
                                <th>User Name</th>
                                <th>Full Name</th>
                                <th>Father's Name</th>
                                <th>Father's Mobile No</th>
                                <th>Gender</th>
                                <th>Marital Status</th>
                                <th>No Of Brothers</th>
                                <th>No of Sisters</th>
                                <th>Manglik</th>
                                <th>Height</th>
                                <th>Blood Group</th>
                                <th>Body Color</th>
                                <th>DOB</th>

                                <th>TOB</th>
                                <th>Address</th>
                                <th>Mobile No</th>
                                <th>Education</th>
                                <th>Sub Caste</th>
                                <th>Profession</th>
                             
                                <th>Per Annum</th>
                                <th>Gotra</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Pincode</th>
                                <th>About</th>
                                <th>Package Name</th>

                            



                                {/* <th>Status</th> */}
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories && categories.map((category, index) => {
                                let statusClass;
                                switch (category.status) {
                                    case 'no':
                                        statusClass = 'text-danger';
                                        break;
                                    case 'yes':
                                    case 'approved':
                                        statusClass = 'text-success';
                                        break;
                                    default:
                                        statusClass = 'text-primary';
                                }

                                return (
                                    <tr key={category.id}>
                                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                                        <td>{category._id}</td>
                                        <td>{category.userName}</td>
                                        <td>{category.fullName}</td>
                                        <td>{category.fathersName}</td>
                                        <td>{category.fatherMobile}</td>
                                        <td>{category.gender}</td>
                                        <td>{category.maritalStatus}</td>
                                        <td>{category.numOfBrothers}</td>
                                        <td>{category.numOfSisters}</td>
                                        <td>{category?.manglik === true ? "Manglik" : "Non-Manglik"}</td>
                                        <td>{category.height}</td>
                                        <td>{category.bloodGroup}</td>
                                        <td>{category.bodyColor}</td>
                                        <td>{formatDate(category.dateOfBirth)}</td>

                                        <td>{category.birthTime}</td>
                                        <td>{category.address}</td>
                                        <td>{category.mobileNo}</td>
                                        <td>{category.education}</td>
                                        <td>{category.subcaste}</td>
                                        <td>{category.profession}</td>
                                     
                                        <td>{category.perAnnum}</td>
                                        <td>{category.gotra}</td>
                                        <td>{category.city}</td>
                                        <td>{category.state}</td>
                                        <td>{category.pincode}</td>
                                        <td>{category.about}</td>
                                        <td>
                                            {category?.createdBy?.selectedPackage?.title
                                                ? category.createdBy.selectedPackage.title
                                                : category?.packageName?.title}
                                        </td>

                                       
                                        {/* <td className={statusClass}>
                                            {category.status === 'no' ? 'Rejected' : category.status === 'yes' || category.status === 'approved' ? 'Approved' : 'Pending'}
                                        </td> */}
                                        <td>{formatDate(category.createdAt)}</td>
                                        <td>
                                            <i className="icon-pencil" onClick={() => handleEdit(category._id)}></i>
                                            &nbsp;&nbsp;
                                            <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category._id)}></i>
                                            {console.log(category.id)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                    </table>
                </div>
                <div className="body">
                    <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    Previous
                                </NavLink>
                            </li>
                            {[...Array(totalPages).keys()].map(page => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <NavLink
                                        to="#"
                                        className="page-link"
                                        onClick={() => handlePageChange(page + 1)}
                                    >
                                        {page + 1}
                                    </NavLink>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    Next
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <ConfirmDeleteModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={() => handleDelete(selectedCategoryId)}
            />
        </div>
    );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(MatrimonyList);
